"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RulerIcon = void 0;
var Preact = __importStar(require("preact"));
var SvgIcon_1 = __importDefault(require("@mui/material/SvgIcon"));
/** Made by opening the svg exported from figma and manually copying the relevant bits into an
 * SvgIcon (and removing fill so it obeys colour setting).
 * Please see https://mui.com/material-ui/icons/#svgicon
 */
function RulerIcon(props) {
    return (Preact.h(SvgIcon_1.default, __assign({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props),
        Preact.h("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M16.5364 1.28045C16.8377 1.18256 17.1622 1.18256 17.4635 1.28045C17.6961 1.35603 17.8647 1.48158 17.9758 1.57587C18.0716 1.65725 18.1722 1.75789 18.2564 1.84215C18.2619 1.84767 18.2673 1.85313 18.2727 1.8585L22.1577 5.7435C22.242 5.82769 22.3426 5.92824 22.424 6.02409C22.5183 6.13517 22.6438 6.30377 22.7194 6.5364C22.8173 6.83766 22.8173 7.16218 22.7194 7.46345C22.6438 7.69609 22.5183 7.86469 22.424 7.97576C22.3426 8.0716 22.242 8.17213 22.1578 8.25632L8.25636 22.1577C8.17217 22.242 8.07161 22.3426 7.97576 22.424C7.86468 22.5183 7.69608 22.6438 7.46345 22.7194C7.16218 22.8173 6.83766 22.8173 6.5364 22.7194C6.30376 22.6438 6.13516 22.5183 6.02409 22.424C5.92825 22.3426 5.82772 22.242 5.74353 22.1578L1.84213 18.2563C1.75787 18.1722 1.65724 18.0716 1.57587 17.9758C1.48158 17.8647 1.35603 17.6961 1.28045 17.4635C1.18256 17.1622 1.18256 16.8377 1.28045 16.5364C1.35603 16.3038 1.48158 16.1352 1.57587 16.0241C1.65725 15.9282 1.75789 15.8277 1.84215 15.7435C1.84767 15.738 1.85313 15.7325 1.8585 15.7271L15.7271 1.8585C15.7325 1.85312 15.738 1.84766 15.7435 1.84213C15.8277 1.75787 15.9282 1.65724 16.0241 1.57587C16.1352 1.48158 16.3038 1.35603 16.5364 1.28045ZM16.9999 3.41414L15.4142 4.99989L16.7071 6.29278C17.0976 6.68331 17.0976 7.31647 16.7071 7.707C16.3165 8.09752 15.6834 8.09752 15.2929 7.707L14 6.4141L12.4142 7.99989L13.7071 9.29278C14.0976 9.68331 14.0976 10.3165 13.7071 10.707C13.3165 11.0975 12.6834 11.0975 12.2929 10.707L11 9.4141L9.41418 10.9999L10.7071 12.2928C11.0976 12.6833 11.0976 13.3165 10.7071 13.707C10.3165 14.0975 9.68338 14.0975 9.29286 13.707L7.99996 12.4141L6.41418 13.9999L7.70707 15.2928C8.0976 15.6833 8.0976 16.3165 7.70707 16.707C7.31655 17.0975 6.68338 17.0975 6.29286 16.707L4.99996 15.4141L3.41414 16.9999L6.99993 20.5857L20.5857 6.99992L16.9999 3.41414Z" })));
}
exports.RulerIcon = RulerIcon;
